/** список логинов */
import _ from "lodash";
import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect } from "react-redux";
import { useRouteMatch, useParams, Link } from "react-router-dom";
import IntlMessages from "util/intlMessages";
import { Table } from "reactstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import qs from "query-string";
import { adminAPI } from "redux/api";
import { history } from "redux/store";
import moment from "components/moment";
import { useIntl } from "react-intl";
import { Finder, FilterButton, Pager, Sorter, TableLoading } from "components/standart";
import { priceValue } from "components/special";
import { FloatCategories, FloatPartners } from "components/special/contents";
import { Popover, PopoverBody } from "reactstrap";

import OrderChannels from "./Order";
import { limit } from "variables";

import { apiUrls, infoLink } from "./init";
// import AddChannel from "./Add";
// import ChannelForm from "./Form";
import { FormButton } from "./Form";

const { api } = adminAPI.actions;

const ChannelTariffs = (props) => {
  const params = useParams();
  const intl = useIntl();
  const { url, path } = useRouteMatch();
  const dateTimeFormat = intl.formatMessage({ id: "dateTimeFormat" });

  const [tariffs, setTariffs] = useState({ total: 0 });
  const [query, setQuery] = useState({});
  const [refresh, setRefresh] = useState(null);

  const refreshHandler = () => setRefresh(Date.now());

  useEffect(() => {
    setQuery({ limit, order: "-createdAt", ...qs.parse(history.location.search) });
  }, [history.location]);

  useEffect(() => {
    const onSuccess = (body) => {
      setTariffs(body);
    };
    const onRequest = () => {
      setTariffs({ total: -1 });
    };

    query.limit &&
      props.getData({ query: { ...query, ...params }, params }, { onSuccess, onRequest });
  }, [query, refresh]);

  return (
    <Fragment>
      <Table responsive style={{ position: "relative" }}>
        <thead>
          <tr className="text-nowrap">
            <th>
              <IntlMessages id="Channels.tariff" />
            </th>

            <th>Дата создания</th>
            <th>Дата оплаты</th>
            <th>Дата окончания</th>

            <th className="text-right col-1">
              {/* <AddChannel refreshHandler={refreshHandler} /> */}
            </th>
          </tr>
        </thead>
        {tariffs.total < 0 && <TableLoading />}
        <tbody>
          {_.map(tariffs.data, (value, key) => {
            return (
              <tr key={key}>
                <td>{value.tariff?.name}</td>

                <td>
                  {value.createdAt
                    ? moment(new Date(value.createdAt)).format(dateTimeFormat)
                    : null}
                </td>
                <td>
                  {value.paidDate ? moment(new Date(value.paidDate)).format(dateTimeFormat) : null}
                </td>
                <td>
                  {value.expiredDate
                    ? moment(new Date(value.expiredDate)).format(dateTimeFormat)
                    : null}
                </td>
                <td className="text-right"></td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="99">
              <Pager query={query} url={url} total={tariffs.total} />
            </td>
          </tr>
        </tfoot>
      </Table>
    </Fragment>
  );
};

export default connect(null, {
  getData: api.get(apiUrls.tariffs),
})(ChannelTariffs);
